import { Tabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs";
import { SERVER_HOST, SERVER_PORT } from "../lib/api";
import { useI18n } from "../lib/i18n";

const clients = [
  { id: "qip", name: "QIP 2005" },
  { id: "miranda", name: "Miranda IM / NG" },
  { id: "icq2003", name: "ICQ 2003b" },
  { id: "pidgin", name: "Pidgin" },
];

const fill = (s) => s.replace("{host}", SERVER_HOST).replace("{port}", SERVER_PORT);

export const ClientGuides = () => {
  const { t } = useI18n();
  return (
  <section id="clients" className="max-w-7xl mx-auto px-5 sm:px-8 py-24">
    <p className="font-mono text-xs text-[#38BDF8]">{t("clEyebrow")}</p>
    <h2 className="mt-2 text-2xl sm:text-3xl font-bold tracking-tight">{t("clTitle")}</h2>
    <Tabs defaultValue="qip" className="mt-10">
      <TabsList className="bg-[#161B22] border border-[#30363D] h-auto flex-wrap p-1 rounded-full">
        {clients.map((c) => (
          <TabsTrigger key={c.id} value={c.id} data-testid={`client-tab-${c.id}`}
            className="rounded-full px-4 py-2 data-[state=active]:bg-[#3FB950] data-[state=active]:text-[#0D1117]">
            {c.name}
          </TabsTrigger>
        ))}
      </TabsList>
      {clients.map((c) => (
        <TabsContent key={c.id} value={c.id} data-testid={`client-guide-${c.id}`} className="mt-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {t("clients")[c.id].map(fill).map((s, i) => (
              <div key={s} className="rise rounded-xl border border-[#30363D] bg-[#161B22]/70 p-6 hover:border-[#3FB950]/60 transition-colors" style={{ animationDelay: `${i * 70}ms` }}>
                <span className="font-mono text-3xl font-extrabold text-[#21262D]">0{i + 1}</span>
                <p className="mt-4 text-sm text-[#F0F6FC] font-mono leading-relaxed">{s}</p>
              </div>
            ))}
          </div>
        </TabsContent>
      ))}
    </Tabs>
  </section>
  );
};
